var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav"}},[_vm._l((_vm.links),function(link,index){return [_c('router-link',{attrs:{"to":_vm.resolved(link.path)}},[_vm._v(_vm._s(link.text))]),(index != _vm.links.length - 1)?_c('span',[_vm._v(" | ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }